// client form
export const SET_ID = 'SET_ID'
export const SET_NAME = 'SET_NAME'
export const SET_WORKSPACE = 'SET_WORKSPACE'
export const SET_SIGNUP_ENABLED = 'SET_SIGNUP_ENABLED'
export const SET_EMAIL_WHITELIST = 'SET_EMAIL_WHITELIST'
export const SET_EMAIL_BLACKLIST = 'SET_EMAIL_BLACKLIST'
export const SET_THEME = 'SET_THEME'
export const SET_SVG_LOGO = 'SET_SVG_LOGO'
export const SET_LOGO = 'SET_LOGO'
export const SET_EMAIL_SIGNATURE = 'SET_EMAIL_SIGNATURE'
export const SET_TAGS = 'SET_TAGS'

// client theme
export const SET_CLIENT_THEME = 'SET_CLIENT_THEME'
export const UPDATE_THEME_PROPERTY = 'UPDATE_THEME_PROPERTY'
export const CLIENT_DEFAULT_LOGO = '/static/foldaz.svg'
export const CLIENT_DEFAULT_THEME = {
  mainColor: '#37c06e',
  mainColorHover: '#2fa75f',
  mainNavLink: '#000',
  mainNavLinkHover: '#37c06e',
  mainNavLinkActive: '#37c06e',
  mainNavLogo: '#37c06e',
  mainNavLogoHover: '#37c06e',
  mainNavLogoActive: '#37c06e',
  linkColor: '#37c06e',
  linkColorHover: '#2fa75f',
  buttonBackground: '#37c06e',
  buttonBackgroundHover: '#2fa75f',
  dropdownBackground: '#000',
  navBarColor: '#37c06e',
  navBarColorHover: '#2fa75f',
  navBarColorActive: '#2fa75f',
  contentAttachmentBackground: '#000',
  contentAttachmentBackgroundHover: '#242928',
  contentItemBackground: '#000',
  addButtonColor: '#37c06e',
  addButtonColorHover: '#2fa75f'
}





// WEBPACK FOOTER //
// ./src/store/modules/clients/types.js